export default __webpack_public_path__ + "media/images/loading_request-d3f19f796146a680c9137faf9b3da78e.gif";